if (!customElements.get('free-shipping-upsell')) {
  class FreeShippingUpsell extends HTMLElement {
    connectedCallback() {
      const qtyInputId  = this.dataset.quantityInput;
      const defaultQty  = parseInt(this.dataset.defaultQty, 10) || 1;
      this.qtyInput     = document.getElementById(qtyInputId);

      // Set initial quantity to match the default selected supply option
      if (this.qtyInput) this.qtyInput.value = defaultQty;

      // Tile click → update quantity input
      this.querySelectorAll('.fsu__option').forEach((btn) => {
        btn.addEventListener('click', () => this.selectOption(btn));
      });

      // Quantity input change → update active tile
      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', () => this.syncFromInput());

        // Also watch the +/- buttons on the quantity-input component
        const qtyWrapper = this.qtyInput.closest('quantity-input');
        if (qtyWrapper) {
          qtyWrapper.querySelectorAll('.quantity__button').forEach((btn) => {
            btn.addEventListener('click', () => {
              // Small delay so the input value updates first
              setTimeout(() => this.syncFromInput(), 10);
            });
          });
        }
      }
    }

    selectOption(selected) {
      this.querySelectorAll('.fsu__option').forEach((btn) =>
        btn.classList.remove('fsu__option--active')
      );
      selected.classList.add('fsu__option--active');

      if (this.qtyInput) {
        this.qtyInput.value = parseInt(selected.dataset.qty, 10);
      }
    }

    syncFromInput() {
      const qty = parseInt(this.qtyInput.value, 10);
      const match = this.querySelector(`.fsu__option[data-qty="${qty}"]`);

      this.querySelectorAll('.fsu__option').forEach((btn) =>
        btn.classList.remove('fsu__option--active')
      );

      if (match) {
        match.classList.add('fsu__option--active');
      }
    }
  }

  customElements.define('free-shipping-upsell', FreeShippingUpsell);
}
